module.exports = __webpack_public_path__ + "img/tips3.d77c8a12.png";